var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Factory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 25.31V30h-4v-4.69C60 20 56.41 16 50.48 16H40.7A11 11 0 0130 5h4a7 7 0 006.7 7h9.78C58.57 12 64 17.85 64 25.31zm-26 20L63.9 32v37H11V45.31L38 32v13.31zM27 59H16v4h11v-4zm0-8H16v4h11v-4zm16 8H31v4h12v-4zm4-4h11v-4H47v4zm0 8h11v-4H47v4zM31 51v4h12v-4H31zm-9.77-28h29.06A2.73 2.73 0 0153 25.73V30h4v-4.27A6.72 6.72 0 0050.29 19H21.67C17.81 19 15 16.48 15 13h-4c0 5.56 4.37 9.78 10.23 10z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Factory.e8557dd9.svg";
export { SvgK1Factory as ReactComponent };